import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import 'rxjs/Rx';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { environment } from '../../../environments/environment';
import { Constantes } from '../constantes';

import { ConsultaSolicitud } from '../models/consulta-solicitud';
import { Mensaje } from '../models/mensaje';

import { AlertaService } from '../components/alerta/alerta.service';

@Injectable()
export class AutenticacionService {
  api: string;
  servicio: string;

  mensaje: string = null;

  constructor(
    private httpClient: HttpClient,
    private alertaService: AlertaService,
    @Inject('LOCAL_STORAGE') private localStorage: any) {
    this.api = environment.api;
    this.servicio = Constantes.SERVICIO_AUTENTICACION;
  }

  login(consultaSolicitud: ConsultaSolicitud): Observable<Mensaje> {
    this.localStorage.setItem(Constantes.SECURITY_TOKEN, null);

    return this.httpClient.post<Mensaje>(this.api + this.servicio + 'generateToken', consultaSolicitud)
      .map(
      (data) => {
        if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
          this.localStorage.setItem(Constantes.SECURITY_TOKEN, data.object);
        }
        return data;
      }
      );
  }

  logout() {
    this.localStorage.removeItem(Constantes.SECURITY_TOKEN);
  }

  getToken() {
    return this.localStorage.getItem(Constantes.SECURITY_TOKEN);
  }

  estaAutenticado() {
    return this.localStorage.getItem(Constantes.SECURITY_TOKEN) != null;
  }

  setMensaje(mensaje: string) {
    this.mensaje = mensaje;
  }

  getMensaje() {
    return this.mensaje;
  }

  validarIp(): Observable<Mensaje> {
    return this.httpClient.get<Mensaje>(this.api + this.servicio + 'validacionIp');
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/services/autenticacion.service.ts